import { AllowedAccess } from 'react-permission-role'
import { useLocation, useParams } from 'react-router-dom'
import { Card, CardContent, Grid } from '@mui/material';

import { useFetchInitAdminPaymentLaywer } from './hooks'
import { TableAdminPaymentLaywer } from './TableAdminPaymentLaywer'
import { FormAdminPaymentLawyer } from './FormAdminPaymentLawyer'


export const AdminPaymentLaywer = () => {

    const location = useLocation();
    const paramsURL = useParams();
    const useFetchInit = useFetchInitAdminPaymentLaywer({location, paramsURL})

    const {
        //------------- Generales
        //------------- globalStates
        globalStates,
        //------------- Helpers
        // Helpers,
        //------------- Formularios
        // Forms,
        //------------- FetchData
        // FetchData,
        //------------- Actions
        // Actions
    } = useFetchInit

    // ------------------------------------------------ Generales
    // ------------------------------------------------ globalStates
    const { showForm } = globalStates
    // ------------------------------------------------ Helpers
    // ------------------------------------------------ Formularios
    // ------------------------------------------------ FetchData
    // ------------------------------------------------ Actions

    return (
        <AllowedAccess permissions={['227_BOLETAS_BANCARIAS']} renderAuthFailed={<p>Error</p>}>
            {(!showForm) && (
                <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                        <Card style={{zIndex:'1'}}>
                            <CardContent>
                                <div className='h4 mt-1 mb-1'> Abogacía y Notariado: Boletas Bancarias</div>
                                <div className="border-bottom border-dark"></div>
                                <div className="pt-4"></div>
                                <TableAdminPaymentLaywer useFetchInit={useFetchInit} />
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            )}
            {(showForm) && (
                <FormAdminPaymentLawyer useFetchInit={useFetchInit} />
            )}
        </AllowedAccess>
    )
}
